import { cn } from "../../lib";

function AspectRatio({
  ratio,
  className,
  ...props
}: React.ComponentProps<"div"> & { ratio: number }) {
  return (
    <div
      data-slot="aspect-ratio"
      style={
        {
          "--ratio": ratio,
        } as React.CSSProperties
      }
      className={cn("aspect-(--ratio) relative", className)}
      {...props}
    />
  );
}

export { AspectRatio };
